module.exports = __webpack_public_path__ + "static/img_0318_dpp_optimized-8aab5c0e8743886e786d6dfea5b59592.jpg";